import React, { useState, useEffect } from 'react';
import { Collapse, Icon, Popover, Input, message, Popconfirm ,Spin, Button} from 'antd';
import {
  Container,
  SettingpageConatiner,
  LoaderContainer,
  UserConatiner,
  Detailwrapper,
  DetailCardContainer,
  DetailHeadingCover,
  CreateButton,
  PopupContainer,
  PopupActionContainer,
  PopupLabel,
  CancelButton,
  SearchBar,
  DeleteRelationshipModal
} from './styles';
import Loader from '../../components/Loader';
import VariableTable from './VariableTable';
import { withTranslation } from 'react-i18next';
import { getAllVariables, getAllVariableCategory } from '../../utils/services/variablesAPI';
import {
  addVariableCategory,
  deleteVariableCategory,
} from '../../utils/services/variablesAPI';
import { ENTITY_RELATION_VARIABLES, MANAGE_DATA_VARIABLES } from './translationValues';
const { Panel } = Collapse;
const format = /[`!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?\s\t~]/g;

const NAMESPACES = ['MANAGE_DATA_VARIABLES'];

const GlobalVariablesPage = props => {
  const [listofVariable, setListofVariable] = useState([]);
  const [allCategory, setAllCategory] = useState([]);
  const [allCategoryList, setAllCategoryList] = useState([]);
  const [duplicateCategory, setDuplicateCategory] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [visible, setVisible] = useState(false);
  const [categoryName, setCategoryName] = useState(null);
  const [savingLoader, setSavingLoader] = useState(false);
  const [updateKey, setUpdateKey] = useState(0);
  const [variableName, setVariableName] = useState('');
  const [isSearching, setIsSearching] = useState(false);
  const [entityToDelete, setEntityToDelete] = useState(null);
  const { t } = props;

  useEffect(() => {
    (async () => {
      let variableResponse = await getAllVariables();
      setListofVariable(variableResponse?.data);
      let categoryResponse = await getAllVariableCategory();
      if (categoryResponse?.data) {
        setAllCategory(categoryResponse?.data);
        setAllCategoryList(categoryResponse?.data)
        setDuplicateCategory(categoryResponse?.data)
      }
      setIsLoading(false);
    })();
    // eslint-disable-next-line
  }, []);

  const handleVisibleChange = visible => {
    setVisible(visible);
  };

  const saveCategoryHandler = async () => {
    let payload = { name: categoryName };
    setSavingLoader(true);
    let response = await addVariableCategory(payload);
    if (response) {
      setSavingLoader(false);
      if (response && response.errors && response.errors.length === 0) {
        payload.id = response.id;
        payload.variableCategoryRefData = {
          usedCount: 0,
        };
        setAllCategory(allCategory => [payload, ...allCategory]);
        setCategoryName(null);
        setVisible(false);
      }
    }
  };

  const deleteHandler = async id => {
    let payload = {
      id: id,
    };
    let deletionResponse = await deleteVariableCategory(payload);
    if (deletionResponse && deletionResponse.errors && deletionResponse.errors.length === 0) {
      let filterCategory = allCategory.filter(item => {
        return item.id !== id;
      });
      setAllCategory(filterCategory);
    }
  };

  const handleChangeInput = e => {
    //eslint-disable-next-line
    let result = format.test(e.target.value);
    if (result) {
      setCategoryName(null);
      message.error(t(MANAGE_DATA_VARIABLES.SPECIAL_CHAR_NOT_ALLOWED_ERROR_MESSAGE.key, MANAGE_DATA_VARIABLES.SPECIAL_CHAR_NOT_ALLOWED_ERROR_MESSAGE.value));
    }
    setCategoryName(e.target.value.replaceAll(format, ''));
  };

  const onSearchVariableList = async (e) => {
    setVariableName(e.target.value);
  };

  function getObjectsWithSameId(arr1, duplicateCategory, arr3) {
    const ids1 = arr1.map(obj => obj.variableCategoryId);
    const ids2 = duplicateCategory.map(obj => obj.id);

    const commonIds = ids1.filter(id => ids2.includes(id));

    const commonCategory = duplicateCategory.filter(obj => commonIds.includes(obj.id));

    const ids3 = commonCategory.map(obj => obj.id);
    const result = arr3.filter(obj => !ids3.includes(obj.id));

    return [...commonCategory, ...result];
  }  

  const Onsearch = async (name = variableName) => {
    setIsSearching(true);
    let payload;

    if (name) {
      payload = { searchParam: name };
    }
    const filterCategory = duplicateCategory.filter((user) =>
      user.name.toLowerCase().includes(name.toLowerCase())
    );
    // When searching by name,  first check the entity's name
    // If no name is provided, it will search the variable list.
    if (filterCategory.length !== 0) {
      const  variableResponse = await getAllVariables();
      if (variableResponse?.statusCode === 1217) {
        const data = variableResponse?.data;
        setListofVariable(data);
      }
      else {
        message.error(t(MANAGE_DATA_VARIABLES.FETCHING_RECORDS_ERROR_MESSAGE.key, MANAGE_DATA_VARIABLES.FETCHING_RECORDS_ERROR_MESSAGE.value))
      }
      setAllCategory(filterCategory);
    } else {
      const variableResponse = await getAllVariables(payload);
      if (variableResponse?.statusCode === 1217) {
        const data = variableResponse?.data;
        setListofVariable(data);
        const filteredItems = duplicateCategory.filter((user) =>
          user.name.toLowerCase().includes(name.toLowerCase())
        );
        const searchResult = getObjectsWithSameId(data, duplicateCategory, filteredItems);
        setAllCategory(searchResult);
      } else {
        message.error(t(MANAGE_DATA_VARIABLES.FETCHING_RECORDS_ERROR_MESSAGE.key, MANAGE_DATA_VARIABLES.FETCHING_RECORDS_ERROR_MESSAGE.value))
      }
    }
    setUpdateKey(Math.random());
    setIsSearching(false);
  };

  const clearSearchbar = () => {
    if (variableName.length !== 0) {
      setVariableName('');
      Onsearch('')
    }
  } 

  return (
    <React.Fragment>
      <Container>
        <UserConatiner>
          {isLoading ? (
            <LoaderContainer>
              <Loader />
            </LoaderContainer>
          ) : (
            <SettingpageConatiner>
              <Detailwrapper>
                <DetailHeadingCover>
                  <div>
                    <h5>{t(MANAGE_DATA_VARIABLES.MANAGE_DATA_VARIABLES_TITLE.key, MANAGE_DATA_VARIABLES.MANAGE_DATA_VARIABLES_TITLE.value)}</h5>
                    <p>{t(MANAGE_DATA_VARIABLES.MANAGE_DATA_VARIABLES_DESCRIPTION.key, MANAGE_DATA_VARIABLES.MANAGE_DATA_VARIABLES_DESCRIPTION.value)}</p>
                  </div>
                  <Popover
                    trigger="click"
                    visible={visible}
                    placement="bottomRight"
                    onVisibleChange={handleVisibleChange}
                    content={
                      <PopupContainer>
                        <PopupLabel>{t(MANAGE_DATA_VARIABLES.ADD_ENTITY_NAME_LABEL.key, MANAGE_DATA_VARIABLES.ADD_ENTITY_NAME_LABEL.value)}</PopupLabel>
                        <Input
                          placeholder={t(MANAGE_DATA_VARIABLES.ADD_ENTITY_NAME_PLACEHOLDER.key, MANAGE_DATA_VARIABLES.ADD_ENTITY_NAME_PLACEHOLDER.value)}
                          autoComplete="off"
                          name="name"
                          value={categoryName}
                          onChange={handleChangeInput}
                          size="default"
                        />
                        <PopupActionContainer>
                          <CancelButton onClick={() => setVisible(false)}>
                            {t(MANAGE_DATA_VARIABLES.CANCEL_NEW_ENTITY_BUTTON.key, MANAGE_DATA_VARIABLES.CANCEL_NEW_ENTITY_BUTTON.value)}
                          </CancelButton>
                          <CreateButton
                            onClick={saveCategoryHandler}
                            loading={savingLoader}
                            disabled={!categoryName}
                            createEntity={1}
                          >
                            {
                              savingLoader
                                ?
                                t(MANAGE_DATA_VARIABLES.SAVING_NEW_ENTITY_BUTTON.key, MANAGE_DATA_VARIABLES.SAVING_NEW_ENTITY_BUTTON.value)
                                :
                                t(MANAGE_DATA_VARIABLES.SAVE_NEW_ENTITY_BUTTON.key, MANAGE_DATA_VARIABLES.SAVE_NEW_ENTITY_BUTTON.value)
                            }
                          </CreateButton>
                        </PopupActionContainer>
                      </PopupContainer>
                    }
                  >
                    <CreateButton type="primary" className="add_user_btn" size="default">
                      {t(MANAGE_DATA_VARIABLES.ADD_ENTITY_BUTTON.key, MANAGE_DATA_VARIABLES.ADD_ENTITY_BUTTON.value)}
                    </CreateButton>
                  </Popover>
                </DetailHeadingCover>
               
                  <SearchBar>
                    <input type="text" value={variableName} placeholder={t(MANAGE_DATA_VARIABLES.SEARCH_BY_NAME_PLACEHOLDER.key, MANAGE_DATA_VARIABLES.SEARCH_BY_NAME_PLACEHOLDER.value)} onChange={(e) => { onSearchVariableList(e) }}
                      onKeyPress={(e) => { e.key === 'Enter' && Onsearch() }} />
                    <div class="icon" onClick={clearSearchbar}>
                      {isSearching ? <Spin /> : variableName.length === 0 ? <Icon type='search' /> : <> &times;</>}
                    </div>
                  </SearchBar>

                <DetailCardContainer key={updateKey}>
                  {allCategory &&
                    allCategory.length > 0 &&
                    allCategory.map((data, index) => {
                      return (
                        <div key={data.id} style={{ position: 'relative' }}>
                          <Collapse
                            key={index}
                            bordered={false}
                            className="site-collapse-custom-collapse collapse-card-style"
                          >
                            <Panel
                              key={index}
                              header={`${data.name}`}
                              className="site-collapse-custom-panel "
                              extra={
                                <div style={{
                                  display: 'flex',
                                  columnGap: '10px',
                                  alignItems: 'center',
                                  marginRight: "10px"
                                }}
                                  onClick={e => e.stopPropagation()}>
                                  <Icon type="delete" onClick={()=>{setEntityToDelete(data)}} />
                                  <DeleteRelationshipModal
                                    height={'200px !important'}
                                    visible={entityToDelete?.id === data.id}
                                    onCancel={() => setEntityToDelete(null)}
                                    bodyStyle={{ padding: '40px' }}
                                    maskClosable={false}
                                    maskStyle={{ opacity: '0.3' }}
                                    footer={[
                                      <Button
                                        type="danger"
                                        onClick={() => {
                                      deleteHandler(data.id);
                                      setEntityToDelete(null)}}
                                      >
                                          {t(ENTITY_RELATION_VARIABLES.DELETE_RELATION_BUTTON.key,
                                          ENTITY_RELATION_VARIABLES.DELETE_RELATION_BUTTON.value )}
                                      </Button>
                                    ]}
                                  >
                                    <div style={{ display: 'flex', gap: '20px' }}>
                                      <Icon type="delete" style={{ fontSize: '50px', color: 'red' }}/>
                                      <div>
                                        <h4>
                                          {t(MANAGE_DATA_VARIABLES.CONFIRM_DELETE_ENTITY_TITLE.key,
                                        MANAGE_DATA_VARIABLES.CONFIRM_DELETE_ENTITY_TITLE.value)}</h4>
                                        <div>{t(MANAGE_DATA_VARIABLES.CONFIRM_DELETE_ENTITY_DESCRIPTION.key,
                                        MANAGE_DATA_VARIABLES.CONFIRM_DELETE_ENTITY_DESCRIPTION.value)}</div>
                                      </div>
                                    </div>
                                  </DeleteRelationshipModal>
                                </div>}
                            >
                              <VariableTable
                                tableData={listofVariable}
                                categoryId={data.id}
                                categoryName={data.name}
                                allCategory={allCategory}
                                allCategoryList={allCategoryList}
                              />
                            </Panel>
                          </Collapse>
                        </div>
                      );
                    })}
                </DetailCardContainer>
              </Detailwrapper>
            </SettingpageConatiner>
          )}
        </UserConatiner>
      </Container>
    </React.Fragment>
  );
};
export default withTranslation(NAMESPACES)(GlobalVariablesPage);